import { render, staticRenderFns } from "./ContentLoaderCreditNotes.vue?vue&type=template&id=126f8cf2&"
import script from "./ContentLoaderCreditNotes.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderCreditNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports